module.exports = __webpack_public_path__ + "img/jd2021_t.246d78db.png";